import { render, staticRenderFns } from "./MigracaoProcesso.vue?vue&type=template&id=475e521a&scoped=true&lang=pug"
import script from "./MigracaoProcesso.vue?vue&type=script&lang=js"
export * from "./MigracaoProcesso.vue?vue&type=script&lang=js"
import style0 from "./MigracaoProcesso.vue?vue&type=style&index=0&id=475e521a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e521a",
  null
  
)

export default component.exports